import $ from 'jquery';
import UrlHelper from './UrlHelper';


class Service {
  constructor() {
    this.urlHelper = new UrlHelper();
  }

  getUrl(method) {
    return this.urlHelper.buildAbsolute(method);
  }

  invoke(relativeUrl, data, method) {
    const fullUrl = this.getUrl(relativeUrl);

    const d = $.Deferred();

    const options = {
      type: method,
      url: fullUrl,
      contentType: 'application/json',
      dataType: 'json',
      success(ret) {
        if (ret && ret.d) {
          d.resolve(ret.d);
        } else {
          d.resolve(ret);
        }
      },
      error(x, h, r) {
        if (x.status === 401) {
          window.location = window.location.pathname;
        }
        d.reject(x, h, r);
      },
    };

    if (data) {
      options.data = JSON.stringify(data);
    }

    $.ajax(options);

    return d;
  }

  get(serviceMethod) {
    return this.invoke(serviceMethod, null, 'GET');
  }

  post(serviceMethod, data = {}) {
    return this.invoke(serviceMethod, data, 'POST');
  }

  put(serviceMethod, data = {}) {
    return this.invoke(serviceMethod, data, 'PUT');
  }

  'delete'(serviceMethod) {
    return this.invoke(serviceMethod, null, 'DELETE');
  }

}

export default Service;



// WEBPACK FOOTER //
// ./V7/tnew/lib/ajax/Service.js